const fullWidthBannerData = [
  { src: "/home/banner1.jpg", alt: "Cheese Spotlight", pos: '1' },
  { src: "/home/banner2.jpg", alt: "100% fresh guarantee", pos: '2' },
  { src: "/home/banner3.jpg", alt: "FoodHero", pos: '3'},
];

const fullWidthIpadBannerData = [
  { "src": "/home/BannerIPad1.jpg", "alt": "Background Image 1" },
  { "src": "/home/BannerIPad2.jpg", "alt": "Background Image 2" },
  { "src": "/home/BannerIPad3.jpg", "alt": "Background Image 3" },
];

const fullWidthMobileBannerData = [
  { src: "/home/mobile_banner.jpg", alt: "Background Image 1", pos: '1' },
  { src: "/home/Banner_mob_3.jpg", alt: "Background Image 2", pos: '2' },
  { src: "/home/Banner_mob-2.jpg", alt: "Background Image 3", pos: '3' },
];

const gridSliderBannerData = [
  { src: "/home/CarosuelImage.svg", alt: "Background Image 1" },
  { src: "/home/CarosuelImage.svg", alt: "Background Image 2" },
  { src: "/home/CarosuelImage.svg", alt: "Background Image 3" },
];

const categoryBannerData = [
  { "title": "Bread & Bakery", "src": "/home/category3.svg", "alt": "category_img" },
  { "title": "Cheese & Deli", "src": "/home/category2.svg", "alt": "category_img" },
  { "title": "Meat", "src": "/home/category4.svg", "alt": "category_img" },
  { "title": "Seafood", "src": "/home/category5.svg", "alt": "category_img" },
  { "title": "Fruits & Vegetables", "src": "/home/category1.svg", "alt": "category_img" },
  { "title": "Plant-based", "src": "/home/plant.svg", "alt": "category_img" },
  { "title": "Dairy & Eggs", "src": "/home/dairy.svg", "alt": "category_img" },
  { "title": "Pantry", "src": "/home/pantry.svg", "alt": "category_img" },
  { "title": "Bread & Bakery", "src": "/home/category3.svg", "alt": "category_img" },
  { "title": "Cheese & Deli", "src": "/home/category2.svg", "alt": "category_img" },
  { "title": "Meat", "src": "/home/category4.svg", "alt": "category_img" },

];

const shopBannerData = [
  {
    title: "Sobeys",
    description: "Freshly baked sourdough loaf",
    src: "/home/product-img-1.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },
  {
    title: "Sobeys",
    description: "Freshly baked sourdough loaf",
    src: "/home/product-img-2.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },
  {
    title: "Sobeys",
    description: "Freshly baked sourdough loaf",
    src: "/home/product-img-3.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },
  {
    title: "Sobeys",
    description: "Freshly baked sourdough loaf",
    src: "/home/product-img-4.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },
  {
    title: "Sobeys",
    description: "Freshly baked sourdough loaf",
    src: "/home/product-img-5.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },
  {
    title: "Sobeys",
    description: "Freshly baked sourdough loaf",
    src: "/home/product-img-6.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },
  {
    title: "Sobeys",
    description: "Freshly baked sourdough loaf",
    src: "/home/product-img-1.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },
  {
    title: "Sobeys",
    description: "Freshly baked sourdough loaf",
    src: "/home/product-img-2.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },

  {
    title: "Sobeys",
    description: "Freshly baked sourdough loaf",
    src: "/home/product-img-1.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },
  {
    title: "Sobeys",
    description: "Freshly baked sourdough loaf",
    src: "/home/product-img-2.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },
  {
    title: "Sobeys",
    description: "Freshly baked sourdough loaf",
    src: "/home/product-img-3.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },
  {
    title: "Sobeys",
    description: "Freshly baked sourdough loaf",
    src: "/home/product-img-4.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },
  {
    title: "Sobeys",
    description: "Freshly baked sourdough loaf",
    src: "/home/product-img-5.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },
];

const exclusiveBannerData = [
  {
    scene_src:"/home/scene-plus.svg",
    scene_point:"5000",
    scene_pts:"PTS",
    title: "Sobeys",
    description: "Expires 30 Jan ‘24",
    src: "/home/exclusive1.svg",
    alt: "Background Image 1",
    price: "When you buy 3",
    sale_price: "",
    weight: "608g($1.69 per 100g)",
  },
  {
    scene_src:"",
    scene_point:"",
    scene_pts:"",
    buy_text:"BUY 1 GET 1",
    free_text:'FREE',
    title: "Sobeys",
    description: "Expires 30 Jan ‘24",
    src: "/home/exclusive2.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },
  {
    scene_src:"/home/scene-plus.svg",
    scene_point:"5000",
    scene_pts:"PTS",
    title: "Sobeys",
    description: "Expires 30 Jan ‘24",
    src: "/home/exclusive3.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },
  {
    scene_src:"/home/scene-plus.svg",
    scene_point:"5000",
    scene_pts:"PTS",
    title: "Sobeys",
    description: "Expires 30 Jan ‘24",
    src: "/home/exclusive4.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },
  {
    scene_src:"/home/scene-plus.svg",
    scene_point:"5000",
    scene_pts:"PTS",
    title: "Sobeys",
    description: "Expires 30 Jan ‘24",
    src: "/home/exclusive5.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },
  {
    scene_src:"/home/scene-plus.svg",
    scene_point:"5000",
    scene_pts:"PTS",
    title: "Sobeys",
    description: "Expires 30 Jan ‘24",
    src: "/home/exclusive6.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },
  {
    scene_src:"/home/scene-plus.svg",
    scene_point:"5000",
    scene_pts:"PTS",
    title: "Sobeys",
    description: "Expires 30 Jan ‘24",
    src: "/home/exclusive4.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },

  {
    scene_src:"/home/scene-plus.svg",
    scene_point:"5000",
    scene_pts:"PTS",
    title: "Sobeys",
    description: "Expires 30 Jan ‘24",
    src: "/home/exclusive1.svg",
    alt: "Background Image 1",
    price: "When you buy 3",
    sale_price: "",
    weight: "608g($1.69 per 100g)",
  },
  {
    scene_src:"/home/scene-plus.svg",
    scene_point:"5000",
    scene_pts:"PTS",
    title: "Sobeys",
    description: "Expires 30 Jan ‘24",
    src: "/home/exclusive2.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },
  {
    scene_src:"/home/scene-plus.svg",
    scene_point:"5000",
    scene_pts:"PTS",
    title: "Sobeys",
    description: "Expires 30 Jan ‘24",
    src: "/home/exclusive3.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },
  {
    scene_src:"/home/scene-plus.svg",
    scene_point:"5000",
    scene_pts:"PTS",
    title: "Sobeys",
    description: "Expires 30 Jan ‘24",
    src: "/home/exclusive4.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },
  {
    scene_src:"/home/scene-plus.svg",
    scene_point:"5000",
    scene_pts:"PTS",
    title: "Sobeys",
    description: "Expires 30 Jan ‘24",
    src: "/home/exclusive5.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },
  {
    scene_src:"/home/scene-plus.svg",
    scene_point:"5000",
    scene_pts:"PTS",
    title: "Sobeys",
    description: "Expires 30 Jan ‘24",
    src: "/home/exclusive6.svg",
    alt: "Background Image 1",
    price: "$2.35",
    sale_price: "$3.99",
    weight: "608g($1.69 per 100g)",
  },
];

const banners = {
  fullWidthBannerData,
  shopBannerData,
  categoryBannerData,
  exclusiveBannerData,
  gridSliderBannerData,
  fullWidthIpadBannerData,
  fullWidthMobileBannerData,
};

export default banners;
